import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getScheduleListApi, scheduleDeleteApi } from "../../api";
import { setScheduleList, scheduleDelete } from "../../redux";
import { FaPen, FaTrashAlt } from "react-icons/fa";
import Cookies from "js-cookie";
import { Schedule } from "./";
import { withRouter } from "react-router-dom";
import { FiZap } from "react-icons/fi";
import { useTranslation } from "react-i18next";

const ScheduleListComp = (props) => {
  const { t } = useTranslation();
  var daysFA = [
    t("شنبه"),
    t("یکشنبه"),
    t("دوشنبه"),
    t("سه شنبه"),
    t("چهارشنبه"),
    t("پنجشنبه"),
    t("جمعه"),
  ];

  const { zone } = props;
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const scheduleList = useSelector((state) => state.scheduleList.scheduleList);
  const [openScheduleModal, setOpenScheduleModal] = useState(false);
  const toggleSchedule = () => setOpenScheduleModal(!openScheduleModal);
  const [scheduleData, setScheduleData] = useState();
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    const data = new FormData();
    data.append("serial", zone.serial);
    data.append("widget", zone.id);
    getScheduleListApi(data, token)
      .then((res) => {
        dispatch(setScheduleList(res.data.data));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("خطایی رخ داده است . لطفا مجددا امتحان کنید."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 2000);
        }
      });
  }, []);

  const deleteSchedule = (id) => {
    const data = new FormData();
    data.append("schedule", id);
    scheduleDeleteApi(data, token)
      .then(() => {
        dispatch(scheduleDelete({ id: id }));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const editSchedule = (value) => {
    toggleSchedule();
    setScheduleData(value);
    console.log("00000");
  };

  return (
    <div style={{ minHeight: "80vh" }}>
      {!openScheduleModal ? (
        <>
          <i className="circleTop icon-plug text-center m-auto"></i>
          <div className="text-center mt-2">
            <p className="m-0">{t("لیست زمانبندی ها")}</p>
          </div>
          <div className="p-2 my-3">
            {scheduleList === null ? (
              <p>{t("زمانبندی برای این ویجت تعریف نشده است.")}</p>
            ) : (
              scheduleList?.map((schedule, index) => {
                let days = schedule.days.split(",");
                return (
                  <div
                    key={index}
                    className="mb-3 bg-white schedulLists p-3 position-relative cursor"
                  >
                    <span
                      className="d-block schedulListsIcon
                                    fn23 d-flex align-items-center justify-content-center rounded-circle m-auto"
                    >
                      <FiZap />
                    </span>
                    <p className="my-3 fn text-center">
                      {schedule.command == "11"
                        ? t("خروجی 1 - خاموش")
                        : t("خروجی 1 - روشن")}
                    </p>

                    <div className="d-flex justify-content-between align-items-center">
                      <p className="text-muted fn12">
                        {t("تاریخ ثبت زمانبندی")}
                      </p>
                      <p className="fn12">{schedule.start_date}</p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <p className="text-muted fn12">{t("ساعت اجرا")}</p>
                      <p className="fn12">{schedule.time}</p>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <p className="text-muted fn12">{t("روزهای اجرا")}</p>
                      <div className="d-flex flex-wrap">
                        {days.map((day, index) => {
                          return (
                            <p key={index} className="fn12">
                              {daysFA[day - 1]} -{" "}
                            </p>
                          );
                        })}
                      </div>
                    </div>
                    <div className="d-flex justify-content-center">
                      <span
                        onClick={() => {
                          editSchedule(schedule);
                          console.log("schedule");
                        }}
                        className="editNameDevice mx-3 d-flex align-items-center justify-content-center rounded-circle"
                        style={{ color: "#4B80E3", fontSize: "18px" }}
                      >
                        <FaPen />
                      </span>
                      <span
                        onClick={() => deleteSchedule(schedule.id)}
                        className="deleteNameDevice mx-3 d-flex align-items-center justify-content-center rounded-circle"
                        style={{ color: "#4B80E3", fontSize: "18px" }}
                      >
                        <FaTrashAlt />
                      </span>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </>
      ) : (
        <Schedule
          zone={zone}
          toggleSchedule={toggleSchedule}
          scheduleData={scheduleData}
        />
      )}
    </div>
  );
};

const ScheduleList = withRouter(ScheduleListComp);

export { ScheduleList };
